export default "__VITE_ASSET__deb17399__"